import { render, staticRenderFns } from "./OrdensTransportePage.vue?vue&type=template&id=b19a5538&"
import script from "./OrdensTransportePage.vue?vue&type=script&lang=js&"
export * from "./OrdensTransportePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports